module.exports = __webpack_public_path__ + "static/media/three-dots-light.a277a2f5.svg";